import PlanoAcaoHandler from "@components/Handlers/PlanoAcaoHandler/Index";
import RelatorioHandler from "@components/Handlers/RelatorioHandler/Index";
import { FormularioOptionProcessoModal } from "@components/Modals/User/FormularioOptionProcessoModal/Index";

function ButtonViewers({
    solicitacaoFields,
    relatorios,
    planosAcao,
}) {

    return (
        <div className="row mt-4">
            <div className="col-12 col-md-12">
                <div className="block h-auto">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="d-flex justify-content-center gap-2">

                                    {/* VISUALIZAR FORMULÁRIOS DO PROCESSO */}
                                    <FormularioOptionProcessoModal
                                        idProcesso={solicitacaoFields?.compliance?.idProcesso}
                                        idSolicitacao={solicitacaoFields?.id}
                                        idFormularioAssociado={solicitacaoFields?.formularioAssociadoProcesso?.id}
                                        formularioModeloInicial={solicitacaoFields?.formularioAssociadoProcesso}
                                        formularioRespostaInicial={solicitacaoFields?.formularioRespostaProcesso}
                                    />

                                    {/* VISUALIZAR RELATÓRIOS */}
                                    <RelatorioHandler
                                        idSolicitacao={solicitacaoFields?.id}
                                        idProcesso={solicitacaoFields?.compliance?.idProcesso}
                                        idUnidadeGerencia={solicitacaoFields?.unidadeGerencia?.id}
                                        flagAuditoria={solicitacaoFields?.compliance?.flagAuditoria}
                                        relatoriosExistentes={relatorios}
                                    />

                                    {/* VISUALIZAR PLANO DE AÇÃO */}
                                    <PlanoAcaoHandler
                                        idSolicitacao={solicitacaoFields?.id}
                                        idProcesso={solicitacaoFields?.compliance?.idProcesso}
                                        idUnidadeGerencia={solicitacaoFields?.unidadeGerencia?.id}
                                        codigoProcesso={solicitacaoFields?.compliance?.codigoProcesso}
                                        flagAuditoria={solicitacaoFields?.compliance?.flagAuditoria}
                                        planosAcaoExistentes={planosAcao}
                                    />

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ButtonViewers;